<div [kgrLoading]="isLoading" [kgrLoadingBlocking]="true">
  @if (mandatory) {
    <div class="kgr-alert kgr-alert--warning kgr-row" i18n>
      Die Einrichtung hat die Zwei-Faktor-Authentifizierung verpflichtend aktiviert, diese muss zunächst eingerichtet werden um den Account
      nutzen zu können.
    </div>
  }
  @if (errorOffline) {
    <kgr-errors errors="Es konnte keine Verbindung zum Server hergestellt werden." i18n-errors></kgr-errors>
  }
  @if (unexpectedError) {
    <kgr-errors errors="Es ist leider ein unerwarteter Fehler aufgetreten." i18n-errors></kgr-errors>
  }

  @if (step === SetupStep.ScanAndVerify && setupData) {
    <h2 class="kgr-headline kgr-headline--h3 kgr-row kgr-row--extraSmallMargin kgr-text--centered" i18n>
      Zwei-Faktor-Authentifizierung einrichten
    </h2>
    <p class="kgr-paragraph kgr-row kgr-text--centered" i18n>
      QR-Code mit der Authenticator-App scannen (z.B. Google Authenticator oder Authy).
    </p>

    <div class="kgr-row kgr-text--centered">
      <img [src]="setupData.setup.qrCode" alt="QR-Code für Authenticator-App" i18n-alt style="width: 180px; height: 180px" />
    </div>

    <p class="kgr-paragraph kgr-row kgr-text--centered" i18n>
      Falls der QR-Code nicht gescannt werden kann, diesen Code manuell in der App eingeben ("zeitbasiert"):
    </p>
    <div class="kgr-row kgr-text--centered">
      <code class="secret-code" (click)="copySecret()" title="Klicken zum Kopieren" i18n-title>{{ setupData.setup.secret }}</code>
      @if (secretCopied) {
        <div class="kgr-alert kgr-alert--info kgr-row copied-to-clipboard" i18n>In die Zwischenablage kopiert</div>
      }
    </div>
    @if (errorInvalidCode) {
      <kgr-errors errors="Der eingegebene Code ist ungültig. Bitte erneut versuchen." i18n-errors></kgr-errors>
    }

    <form (submit)="onVerifyCode()" [formGroup]="codeForm">
      <div class="kgr-text--centered">
        <kgr-form-field label="Authentifizierungscode" i18n-label [constrainedWidth]="false">
          <kgr-code-input formControlName="code" [length]="6" class="kgr-grid--inline"></kgr-code-input>
        </kgr-form-field>
        <br />
        <button [disabled]="isLoading" type="submit" class="kgr-button kgr-button--block kgr-button--accent" i18n>Bestätigen</button>
      </div>
      <div class="kgr-grid kgr-grid--full kgr-grid--large-fit kgr-grid--gutters kgr-grid--bottom kgr-row">
        <div class="kgr-grid__cell"></div>
        <div class="kgr-grid__cell kgr-grid__cell--bottom"></div>
      </div>
    </form>
  }

  @if (step === SetupStep.BackupCodes) {
    <h2 class="kgr-headline kgr-headline--h3 kgr-row kgr-row--extraSmallMargin" i18n>Backup-Codes sichern</h2>
    <p class="kgr-paragraph kgr-row" i18n>
      Diese Backup-Codes bitte an einem sicheren Ort aufbewahren. Jeder Code kann einmalig verwendet werden, falls kein Zugriff auf die
      Authenticator-App besteht.
    </p>

    <kgr-backup-codes [codes]="backupCodes"></kgr-backup-codes>
    <br />
    <kgr-checkbox-control
      [formControl]="backupCodesConfirmed"
      label="Ich habe meine Backup Codes gespeichert."
      i18n-label
      [required]="true"
      class="kgr-row"
    ></kgr-checkbox-control>
    <button
      type="button"
      class="kgr-button kgr-button--block kgr-button--accent kgr-row"
      [disabled]="!backupCodesConfirmed.value"
      (click)="onSetupComplete()"
      i18n
    >
      Codes gesichert – Weiter zur App
    </button>
  }
</div>
